import { render, staticRenderFns } from "./PopulationTrendArray.vue?vue&type=template&id=5cf4782b&"
import script from "./PopulationTrendArray.vue?vue&type=script&lang=js&"
export * from "./PopulationTrendArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports